import { render } from "./Emails-tab.vue?vue&type=template&id=0965f691&scoped=true"
import script from "./Emails-tab.vue?vue&type=script&lang=js"
export * from "./Emails-tab.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=0965f691&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0965f691"]])

export default __exports__